var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.139 160.811C139.289 160.888 137.516 160.174 135.864 159.033C127.898 153.544 118.022 157.727 116.359 167.277C115.601 171.646 112.033 174.846 107.575 174.928C102.536 175.021 97.4909 175.016 92.4459 174.928C87.9993 174.851 84.4035 171.646 83.6404 167.299C81.9716 157.765 72.0792 153.577 64.1191 159.038C60.0897 161.805 55.5168 161.437 52.0364 158.006C48.6657 154.686 45.317 151.338 41.9957 147.968C38.5098 144.433 38.153 139.866 40.9856 135.766C46.3545 128.005 42.1879 118.01 32.8829 116.358C28.1398 115.513 25.0546 111.929 25.0217 107.137C24.9887 102.351 24.9887 97.5707 25.0217 92.7846C25.0546 88.0643 28.1617 84.4308 32.7731 83.6185C42.1989 81.9664 46.3875 72.0209 40.9637 64.1666C38.142 60.0721 38.5153 55.5164 42.0177 51.9708C45.306 48.6391 48.6218 45.3295 51.9485 42.0363C55.5058 38.518 60.0458 38.1283 64.1411 40.9385C71.9749 46.3174 81.8783 42.2668 83.5965 32.9745C84.5298 28.0072 88.0487 25.0324 93.0607 25.0104C97.694 24.9939 102.322 24.9939 106.955 25.0104C111.962 25.0269 115.492 28.0182 116.397 32.98C118.083 42.1954 128.03 46.3229 135.738 41.0154C139.937 38.1228 144.461 38.4851 148.056 42.0472C151.383 45.3404 154.699 48.6501 157.987 51.9817C161.473 55.511 161.841 60.083 159.019 64.1831C153.683 71.9386 157.696 81.7907 166.913 83.5746C172.107 84.579 174.972 87.9984 174.983 93.2456C174.994 97.7738 175 102.302 174.983 106.83C174.967 111.951 172.03 115.436 166.957 116.386C157.79 118.104 153.705 128.071 159.019 135.783C161.841 139.883 161.479 144.455 157.993 147.984C154.666 151.354 151.306 154.686 147.952 158.028C146.124 159.845 143.95 160.872 141.134 160.817L141.139 160.811ZM51.4874 99.9802C51.4874 126.798 73.221 148.511 100.044 148.489C126.811 148.467 148.485 126.809 148.523 100.052C148.561 73.2174 126.877 51.4878 100.044 51.4713C73.2155 51.4493 51.4929 73.1516 51.4929 99.9802H51.4874Z",
    fill: "url(#paint0_linear_75_61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9891 56.335C124.045 56.3075 143.627 75.8747 143.654 99.9645C143.681 124.016 124.111 143.605 100.016 143.632C75.9662 143.66 56.379 124.087 56.3461 99.9974C56.3186 75.946 75.8894 56.3624 99.9836 56.335H99.9891ZM138.642 100.036C138.664 78.6574 121.426 61.3846 100.06 61.3571C78.6891 61.3297 61.3966 78.5751 61.3746 99.9315C61.3527 121.304 78.5958 138.588 99.9561 138.616C121.322 138.643 138.625 121.387 138.642 100.036Z",
    fill: "url(#paint1_linear_75_61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9726 133.752C81.3351 133.703 66.2385 118.598 66.233 99.9859C66.2275 81.3298 81.5438 66.0604 100.115 66.214C118.824 66.3677 133.855 81.4835 133.773 100.057C133.69 118.713 118.555 133.802 99.9671 133.758L99.9726 133.752ZM77.7723 102.203C77.7723 104.618 77.7504 107.039 77.7778 109.454C77.7998 111.139 78.7879 112.27 80.1878 112.313C81.6371 112.357 82.6691 111.183 82.7185 109.415C82.7405 108.488 82.735 107.566 82.7185 106.638C82.7131 106.128 82.768 105.705 83.4322 105.727C84.7662 105.765 86.3143 105.387 87.3628 105.947C88.1643 106.375 87.5385 108.043 87.6483 109.152C87.6593 109.256 87.6483 109.355 87.6483 109.459C87.7087 111.144 88.6694 112.275 90.0692 112.313C91.5185 112.352 92.578 111.183 92.589 109.41C92.6109 104.679 92.6384 99.9474 92.589 95.2162C92.5396 90.968 89.2952 87.6748 85.2438 87.6363C81.143 87.5979 77.8492 90.946 77.7833 95.2601C77.7449 97.5763 77.7778 99.8871 77.7778 102.203H77.7723ZM97.5352 99.9913C97.5352 103.125 97.5187 106.259 97.5407 109.388C97.5571 111.166 98.5837 112.33 100.033 112.313C101.477 112.297 102.454 111.128 102.481 109.339C102.503 107.95 102.481 106.567 102.481 105.178C102.481 103.44 103.338 102.529 105.051 102.445C109.003 102.253 112.055 99.3217 112.341 95.4412C112.604 91.8077 109.98 88.52 106.159 87.779C104.331 87.4223 102.47 87.6473 100.626 87.6363C98.4629 87.6254 97.5517 88.5639 97.5352 90.7429C97.5187 93.8221 97.5352 96.9067 97.5352 99.9859V99.9913ZM122.244 99.931C122.244 96.9012 122.255 93.877 122.244 90.8472C122.239 88.8329 121.256 87.6089 119.719 87.6473C118.231 87.6857 117.304 88.8713 117.298 90.7978C117.287 96.9012 117.287 103.01 117.298 109.114C117.298 111.128 118.286 112.352 119.818 112.313C121.3 112.275 122.233 111.089 122.239 109.163C122.25 106.084 122.239 103.005 122.239 99.9255L122.244 99.931Z",
    fill: "url(#paint2_linear_75_61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6482 97.4226C87.6482 100.919 87.6482 100.869 84.0689 100.891C82.9875 100.897 82.6252 100.606 82.6965 99.5138C82.7844 98.1306 82.702 96.7365 82.724 95.3534C82.7459 93.6354 83.6517 92.609 85.1394 92.5816C86.693 92.5541 87.6208 93.6025 87.6482 95.4192C87.6592 96.0888 87.6482 96.7585 87.6482 97.4226Z",
    fill: "url(#paint3_linear_75_61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.481 94.9857C102.591 93.8825 101.839 92.3402 104.134 92.5378C106.341 92.7299 107.439 93.4159 107.406 95.101C107.373 96.7092 106.302 97.505 104.167 97.5105C103.043 97.5105 102.481 96.6689 102.481 94.9857Z",
    fill: "url(#paint4_linear_75_61)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_61",
    x1: 99.9953,
    y1: 24.998,
    x2: 99.9953,
    y2: 174.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_61",
    x1: 100,
    y1: 56.335,
    x2: 100,
    y2: 143.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_61",
    x1: 100.003,
    y1: 66.2129,
    x2: 100.003,
    y2: 133.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_61",
    x1: 85.1705,
    y1: 92.5811,
    x2: 85.1705,
    y2: 100.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_61",
    x1: 104.927,
    y1: 92.5205,
    x2: 104.927,
    y2: 97.5105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIntegration);
export default __webpack_public_path__ + "static/media/API_Integration.952414a942274b9bbb6757890507f76b.svg";
export { ForwardRef as ReactComponent };